var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.show_notification && !_vm.isHasSubscriptionMessage)?_c('b-navbar',{class:_vm.notiClass,attrs:{"id":"notification-header"}},[_c('b-nav-text',{staticClass:"mr-auto ml-auto pt-0 pb-0",class:_vm.notiClass},[_c('i',{class:{
                    'cus-exclamation':
                        _vm.variant == 'danger' || _vm.variant == 'error',
                    'cus-error': _vm.variant == 'warning',
                    'cus-information': _vm.variant == 'info'
                }}),_c('span',{class:{
                    'text-danger':
                        _vm.variant == 'danger' || _vm.variant == 'error',
                    'alert-warning': _vm.variant == 'warning',
                    'text-info': _vm.variant == 'info'
                },domProps:{"innerHTML":_vm._s(_vm.message)}})]),_c('b-nav-item',{staticClass:"float-right",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.close($event)}}},[_vm._v("×")])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }